import React, { createContext, useMemo, useState, useContext } from "react"

export const AnalyteContext = createContext(null)

export const AnalyteContextProvider = ({ children }) => {
  const [dataAnalyte, setDataAnalyte] = useState([])
  const [launchAnalysis, setLaunchAnalysis] = useState([])
  const [reload, setReload] = useState(false)

  const value = useMemo(() => {
    return {
      dataAnalyte,
      setDataAnalyte,
      reload,
      setReload,
      launchAnalysis,
      setLaunchAnalysis,
    }
  }, [dataAnalyte, setDataAnalyte, reload, setReload, launchAnalysis, setLaunchAnalysis])

  return <AnalyteContext.Provider value={value}>{children}</AnalyteContext.Provider>
}

export default AnalyteContext

export function useAnalyte() {
  return useContext(AnalyteContext)
}
